'use strict';

const $ = require('jquery');

$.fn.productSlider = function (options) {
	let sliderOptions = $.extend({
		imageList: [],
		animate: false,
		duration: 5000, //how long will each image display if animate = true
		scrollable: false,
		callback: () => {}
	}, options);
	let slideCount = sliderOptions.imageList.length,
		thumbnailList = ``,
		displayList = ``,
		that = $(this),
		template = ``,
		currentIndex = 0,
		animInterval,
		thumbnailTemplate,
		i,
		updateimg = (index, fromAnim) => {
			if (typeof animInterval !== 'undefined' && !fromAnim)
				clearInterval(animInterval);
			$('.product-alt-image, .details-image').removeClass('active');
			$('#slide_Thumb_' + index).addClass('active');
			$('#slide_img_' + index).addClass('active');
			currentIndex = index;
			if (sliderOptions.scrollable){
				let leftValue = index > 2 ? (index - 2) * -83 : 0; 
				$('.scrollable-images').animate({left: leftValue});
			}
		},
		nextSlide = () => {
			if(currentIndex + 2 > slideCount)
				currentIndex = 0;
			else
				currentIndex = currentIndex + 1;
			updateimg(currentIndex, false);
		},
		prevSlide = () => {
			if(currentIndex - 1 <= 0)
				currentIndex = 0;
			else
				currentIndex = currentIndex - 1;
			updateimg(currentIndex, false);
		};
	for (i = 0; i < sliderOptions.imageList.length; i++) {
		let url = window.jenkon.imageEndpoint + sliderOptions.imageList[i].imageResourceKey;
		let alt = sliderOptions.imageList[i].imageAlt;
		let activeClass = i === 0 ? 'active' : '';
		thumbnailList+=`<li class="product-alt-image ${activeClass}" id="slide_Thumb_${i}">
							<a href="javascript:void(0);" class="thumb-slider-links" role="button" data-index="${i}">
								<img src="${url}" alt="${alt}" />
							</a>
						</li>`;
		displayList+=`<li class="details-image ${activeClass}" id="slide_img_${i}">
							<img src="${url}" alt="${alt}" />
						</li>`;
	}
	if(sliderOptions.scrollable){
		thumbnailTemplate = `<div class="scrollable">
						<span class="left-arrow"></span>
						<div class="scrollable-container">
							<ul class="scrollable-images clearfix">
								${thumbnailList}
							</ul>
						</div>
						<span class="right-arrow"></span>
					</div>`;
	} else {
		thumbnailTemplate = `<ul class="product-alt-images clearfix">
								${thumbnailList}
							</ul>`;
	}
	template = `<div class="product-details-image">
					<ul class="product-details-images clearfix">
						${displayList}
					</ul>
					${thumbnailTemplate}
				</div>`;
	setTimeout(function(){
		that.append(template);
		sliderOptions.callback();
		$('.thumb-slider-links').on('click', function(){
			updateimg($(this).data('index'), false);
		});
		if(sliderOptions.scrollable){
			$('.right-arrow').on('click', function(){ nextSlide() });
			$('.left-arrow').on('click', function(){ prevSlide() });
		}
	}, 0);
	if(sliderOptions.animate){
		animInterval = setInterval(function(){
			if(currentIndex + 2 > slideCount)
				currentIndex = 0;
			else
				currentIndex = currentIndex + 1;
			updateimg(currentIndex, true);
		}, sliderOptions.duration)
	}
}


// WEBPACK FOOTER //
// ./../../Deploy/PWS/Scripts/product-img-slider.js